import {Colors} from '../../../../theme/colours'
import {type IconStyleProps} from '../icon.types'
import {ExpandIconContainer, RotatingContainer} from './expand-icon.styled'

export type ExpandIconProps = {
    isExpanded: boolean
    color?: string
} & Omit<IconStyleProps, 'color'>

export function ExpandIcon({isExpanded, color = Colors.blue2}: ExpandIconProps) {
    return (
        <ExpandIconContainer>
            <RotatingContainer isExpanded={isExpanded}>
                <Line color={color} />
            </RotatingContainer>
            <RotatingContainer isExpanded={true}>
                <Line color={color} />
            </RotatingContainer>
        </ExpandIconContainer>
    )
}

function Line({color}: IconStyleProps) {
    return (
        <svg
            width="14"
            height="2"
            viewBox="0 0 14 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M14 2.18025H0V0H14V2.18025Z" fill={color} />
        </svg>
    )
}
